import { createSlice } from '@reduxjs/toolkit';
import { difference, union } from 'es-toolkit';

import { fetchAllCategoriesLandingPageData, loadCategories } from '@/redux/modules/category/category.actions';
import { defaultCategorySlice } from '@/redux/modules/category/category.types';

const categorySlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(loadCategories.pending, (state, { meta }) => {
            state.loading = union(state.loading, meta.arg);
        });
        builder.addCase(loadCategories.fulfilled, (state, { meta, payload }) => {
            const actionTime = Date.now();
            // category-api returns null for deleted category ids
            const categories = payload?.payload;
            const returnedIds = (categories ?? []).map((category) => {
                state.byId[category.categoryId] = category;
                state.loaded[category.categoryId] = actionTime;
                return category.categoryId;
            });
            state.loading = difference(state.loading, meta.arg);
            // an empty body isn't an answer; only an explicit null/array means the ids don't exist
            if (categories !== undefined) {
                state.missing = difference(union(state.missing, meta.arg), returnedIds);
            }
        });
        builder.addCase(loadCategories.rejected, (state, { meta }) => {
            state.loading = difference(state.loading, meta.arg);
        });

        builder.addCase(fetchAllCategoriesLandingPageData.fulfilled, (state, { payload }) => {
            state.loaded = payload.payload;
        });
    },
    initialState: defaultCategorySlice,
    name: 'category',
    reducers: {},
});

export const { reducer: categoryReducer } = categorySlice;
